/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimOrganizationsResponseMeta } from './ClaimOrganizationsResponseMeta';
import {
    ClaimOrganizationsResponseMetaFromJSON,
    ClaimOrganizationsResponseMetaFromJSONTyped,
    ClaimOrganizationsResponseMetaToJSON,
    ClaimOrganizationsResponseMetaToJSONTyped,
} from './ClaimOrganizationsResponseMeta';
import type { ClaimProperty } from './ClaimProperty';
import {
    ClaimPropertyFromJSON,
    ClaimPropertyFromJSONTyped,
    ClaimPropertyToJSON,
    ClaimPropertyToJSONTyped,
} from './ClaimProperty';

/**
 * 
 * @export
 * @interface ClaimPropertiesResponse
 */
export interface ClaimPropertiesResponse {
    /**
     * 
     * @type {Array<ClaimProperty>}
     * @memberof ClaimPropertiesResponse
     */
    claimProperties: Array<ClaimProperty>;
    /**
     * 
     * @type {ClaimOrganizationsResponseMeta}
     * @memberof ClaimPropertiesResponse
     */
    meta: ClaimOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ClaimPropertiesResponse interface.
 */
export function instanceOfClaimPropertiesResponse(value: object): value is ClaimPropertiesResponse {
    if (!('claimProperties' in value) || value['claimProperties'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ClaimPropertiesResponseFromJSON(json: any): ClaimPropertiesResponse {
    return ClaimPropertiesResponseFromJSONTyped(json, false);
}

export function ClaimPropertiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPropertiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimProperties': ((json['claimProperties'] as Array<any>).map(ClaimPropertyFromJSON)),
        'meta': ClaimOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ClaimPropertiesResponseToJSON(json: any): ClaimPropertiesResponse {
    return ClaimPropertiesResponseToJSONTyped(json, false);
}

export function ClaimPropertiesResponseToJSONTyped(value?: ClaimPropertiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimProperties': ((value['claimProperties'] as Array<any>).map(ClaimPropertyToJSON)),
        'meta': ClaimOrganizationsResponseMetaToJSON(value['meta']),
    };
}

